module.exports = __webpack_public_path__ + "img/tz_sheep1.fddf207a.png";